import React from 'react';
import { Link } from 'react-router-dom';
import { FiInfo, FiPlusCircle, FiTool, FiRefreshCw } from 'react-icons/fi';
import {
  APP_NAME,
  APP_VERSION,
  getCopyrightText,
  getReleases,
} from '../constants/appInfo';

function ReleaseSection({ icon: Icon, title, items, colorClass }) {
  if (!items?.length) return null;
  return (
    <div className="mt-4">
      <h4 className={`text-sm font-semibold flex items-center gap-1.5 ${colorClass}`}>
        <Icon className="h-4 w-4" />
        {title}
      </h4>
      <ul className="mt-2 space-y-1.5 text-sm text-gray-700 list-disc list-inside">
        {items.map((item) => (
          <li key={item}>{item}</li>
        ))}
      </ul>
    </div>
  );
}

function About() {
  const releases = getReleases();

  return (
    <div className="max-w-3xl">
      <div className="mb-8">
        <h1 className="text-2xl sm:text-3xl font-bold text-gray-900 flex items-center gap-2">
          <FiInfo className="h-7 w-7 text-primary-600" />
          О программе
        </h1>
        <p className="mt-2 text-sm text-gray-600">
          {APP_NAME} — система бронирования складского оборудования АКМЕТРОН
        </p>
      </div>

      <div className="bg-white shadow rounded-lg p-6 mb-8 border border-primary-100">
        <div className="flex flex-wrap items-center gap-3">
          <span className="inline-flex items-center px-3 py-1 rounded-full text-sm font-semibold bg-primary-100 text-primary-800">
            Версия {APP_VERSION}
          </span>
          {releases[0] && (
            <span className="text-sm text-gray-500">
              Последнее обновление: {releases[0].date.split('-').reverse().join('.')}
            </span>
          )}
        </div>
        <p className="mt-3 text-sm text-gray-600">{getCopyrightText()}</p>
        <p className="mt-2 text-sm text-gray-500">
          Production:{' '}
          <a
            href="https://warehouse.akmetron.ru"
            className="text-primary-600 hover:text-primary-700"
            target="_blank"
            rel="noopener noreferrer"
          >
            warehouse.akmetron.ru
          </a>
        </p>
      </div>

      <h2 className="text-lg font-semibold text-gray-900 mb-4">История изменений</h2>

      <div className="space-y-6">
        {releases.map((release, index) => (
          <article
            key={release.version}
            className={`bg-white shadow rounded-lg p-6 ${
              index === 0 ? 'ring-2 ring-primary-200' : ''
            }`}
          >
            <div className="flex flex-wrap items-baseline justify-between gap-2">
              <div>
                <h3 className="text-base font-semibold text-gray-900">
                  v{release.version}
                  {index === 0 && (
                    <span className="ml-2 text-xs font-medium text-primary-600 uppercase">
                      текущая
                    </span>
                  )}
                </h3>
                {release.title && (
                  <p className="text-sm text-gray-600 mt-0.5">{release.title}</p>
                )}
              </div>
              <time className="text-sm text-gray-400 whitespace-nowrap">
                {release.date.split('-').reverse().join('.')}
              </time>
            </div>

            <ReleaseSection
              icon={FiPlusCircle}
              title="Добавлено"
              items={release.added}
              colorClass="text-green-700"
            />
            <ReleaseSection
              icon={FiTool}
              title="Исправлено"
              items={release.fixed}
              colorClass="text-amber-700"
            />
            <ReleaseSection
              icon={FiRefreshCw}
              title="Изменено"
              items={release.changed}
              colorClass="text-blue-700"
            />
          </article>
        ))}
      </div>

      <p className="mt-8 text-xs text-gray-400">
        Вопросы по работе системы — к администратору IT АКМЕТРОН.{' '}
        <Link to="/profile" className="text-primary-600 hover:text-primary-700">
          Профиль и смена пароля
        </Link>
      </p>
    </div>
  );
}

export default About;
